/** Metadata management permission codes. */
export const MD_PERMISSIONS = {
  MANAGE_MASTER_DATA: 'MANAGE_MASTER_DATA',
} as const;

export type MdPermissionCode = (typeof MD_PERMISSIONS)[keyof typeof MD_PERMISSIONS];
